import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { PermissionGuard } from './_guards/permission.guard';
import { ReverseAuthGuard } from './_guards/reverse-auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full', },
  { path: 'login', loadChildren: () => import('./login/login.module').then((m) => m.LoginPageModule), canLoad: [ReverseAuthGuard], },
  { path: 'user-activation', loadChildren: () => import('./user-activation/user-activation.module').then( (m) => m.UserActivationPageModule ), },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardPageModule),  },
  { path: 'listing-user-manage', 
    loadChildren: () => import('./listing-user-manage/listing-user-manage.module').then( (m) => m.ListingUserManagePageModule ), 
    canLoad: [AuthGuard], 
  },
  {
    path: 'add-user-manage',
    loadChildren: () =>
      import('./add-user-manage/add-user-manage.module').then(
        (m) => m.AddUserManagePageModule
      ),
      canLoad: [AuthGuard], 
    
  },
  {
    path: 'edit-your-profile',
    loadChildren: () =>
      import('./edit-your-profile/edit-your-profile.module').then(
        (m) => m.EditYourProfilePageModule
      ),
      canLoad: [AuthGuard], 
  },
  {
    path: 'listing-role',
    loadChildren: () =>
      import('./listing-role/listing-role.module').then(
        (m) => m.ListingRolePageModule
      ),
      canLoad: [AuthGuard], 
  },
  {
    path: 'add-role-manage',
    loadChildren: () =>
      import('./add-role-manage/add-role-manage.module').then(
        (m) => m.AddRoleManagePageModule
      ),
      canLoad: [AuthGuard], 
  },

  {
    path: 'change-password',
    loadChildren: () =>
      import('./change-password/change-password.module').then(
        (m) => m.ChangePasswordPageModule
      ),
      canLoad: [AuthGuard], 
  },
  {
    path: 'home-page',
    loadChildren: () =>
      import('./home-page/home-page.module').then((m) => m.HomePagePageModule),
  },
  {
    path: 'permission',
    loadChildren: () =>
      import('./permission/permission.module').then(
        (m) => m.PermissionPageModule
      ),
      canLoad: [AuthGuard], 
  },
  {
    path: 'permission-settings',
    loadChildren: () =>
      import('./permission-settings/permission-settings.module').then(
        (m) => m.PermissionSettingsPageModule
      ),
      canLoad: [AuthGuard], 
  },
 
  {
    path: 'new-customer-registration',
    loadChildren: () =>
      import(
        './new-customer-registration/new-customer-registration.module'
      ).then((m) => m.NewCustomerRegistrationPageModule),
    canLoad: [PermissionGuard],
    data: { permission: 'NEW_CUSTOMER_REGISTRATION.LISTING' },
  },
  {
    path: 'add-new-customer-registration',
    loadChildren: () =>
      import(
        './add-new-customer-registration/add-new-customer-registration.module'
      ).then((m) => m.AddNewCustomerRegistrationPageModule),
    canLoad: [PermissionGuard],
    data: { permission: 'NEW_CUSTOMER_REGISTRATION.UPDATE' },
  },
  {
    path: 'listing-doc-status',
    loadChildren: () => import('./listing-doc-status/listing-doc-status.module').then( m => m.ListingDocStatusPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'update-status',
    loadChildren: () => import('./update-status/update-status.module').then( m => m.UpdateStatusPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'add-display-board-detail',
    loadChildren: () => import('./add-display-board-detail-manage/add-display-board-detail-manage.module').then( m => m.AddDisplayBoardDetailPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'listing-display-board',
    loadChildren: () => import('./listing-display-board/listing-display-board.module').then( m => m.ListingDisplayBoardPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'add-display-board-manage',
    loadChildren: () => import('./add-display-board-manage/add-display-board-manage.module').then( m => m.AddDisplayBoardManagePageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'listing-clinic-status',
    loadChildren: () => import('./listing-clinic-status/listing-clinic-status.module').then( m => m.ListingClinicStatusPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'add-clinic-status-manage',
    loadChildren: () => import('./add-clinic-status-manage/add-clinic-status-manage.module').then( m => m.AddClinicStatusManagePageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'listing-clinic-room',
    loadChildren: () => import('./listing-clinic-room/listing-clinic-room.module').then( m => m.ListingClinicRoomPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'add-clinic-room-manage',
    loadChildren: () => import('./add-clinic-room-manage/add-clinic-room-manage.module').then( m => m.AddClinicRoomManagePageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'listing-doctor-room',
    loadChildren: () => import('./listing-doctor-room/listing-doctor-room.module').then( m => m.ListingDoctorRoomPageModule),
    canLoad: [AuthGuard], 
  },
  {
    path: 'add-doctor-room-manage',
    loadChildren: () => import('./add-doctor-room-manage/add-doctor-room-manage.module').then( m => m.AddDoctorRoomManagePageModule),
    canLoad: [AuthGuard], 
  },
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
